module.exports = __webpack_public_path__ + "static/media/073.61b5c11d.jpg";